<script>
import API from "@/core/api";

export default {
    data(){
      return {
          api: API.API_HOME
      }
      },
          props: {
          course: {},
      },
    }
</script>


<template v-if="course.level">

  <!-- start card -->
  <div class="card mb-2 c-course-m-div">
    <img class="card-img-top w-50 mx-auto" src="/images/myuni/graduate_icon.svg" alt="graduate icon">
    <div class="">
      <h5 class="c-course-title">
        {{course.title}}
      </h5>
      <small>
        <router-link
          :to="{name: 'UniCourses',  params: { uni_name: course.user_slug.toLowerCase().trim() }}"
           class="c-course-institute">{{course.user}}</router-link
        >
      </small>
      <hr class="c-user-hr-25">
      <p class="mb-0 c-course-degree">{{course.level}}  | {{course.duration}}</p>
      <small class="c-course-location">{{course.city}} , {{course.country}}</small>
      <div>
        <span class="fa fa-star fa-xs text-warning f_z_10_px"></span>
        <span class="fa fa-star fa-xs text-warning f_z_10_px"></span>
        <span class="fa fa-star fa-xs text-warning f_z_10_px"></span>
        <span class="fa fa-star fa-xs text-muted f_z_10_px"></span>
        <span class="fa fa-star fa-xs text-muted f_z_10_px"></span>
        <span class="f_z_10_px"> (3)</span>
      </div>
      <div class="flex-show mt-5 mb-5">
        <router-link
                    class="btn btn-sm btn-light mr-2 text-primary" 
                    :to="{name: 'ListingDetail',  params: { country: course.country.toLowerCase().trim(), city : course.city.toLowerCase().trim(), uni_name: course.user_slug.toLowerCase().trim(), level: course.level.replace(' ','-').toLowerCase().trim(), slug:course.slug,uni_id: course.user_id, id:course.id }}"
          > More </router-link>
        <router-link 
                      class="btn btn-sm btn-primary"
                      :to="{name: 'ListingDetail',  params: { country: course.country.toLowerCase().trim(), city : course.city.toLowerCase().trim(), uni_name: course.user_slug.toLowerCase().trim(), level: course.level.replace(' ','-').toLowerCase().trim(), slug:course.slug,uni_id: course.user_id, id:course.id }}"                             
          > Apply </router-link>

      </div>
    </div>
  </div>
  <!--end card-->
</template>


<style scoped>
.text-primary {
  color: #185AA5 !important;
}
.btn-primary {
  background-color: #185AA5 !important;
}
.btn-sm {
  padding: 1px 16px !important;
  border-radius: 3px !important;
  font-weight: bold;
}

</style>